import "../scss/pages.scss";
import initOurTeamSlider from "../components/our-team";

initOurTeamSlider();
